export default __webpack_public_path__ + "static/media/T7.2e0068d1.jpeg";